// University image mapping utility
// Maps college names to their image files from src/assets/images/university/

// Static mapping for known colleges to their image filenames
const collegeImageMap = {
  "University of Delhi": "university_of_delhi.png",
  "Delhi University": "university_of_delhi.png",
  "Delhi University (General)": "university_of_delhi.png",
  "Banaras Hindu University": "banaras_hindu_university.png",
  "Jawaharlal Nehru University": "jawaharlal_nehru_university.png",
  "Jamia Millia Islamia": "jamia_millia_islamia.png",
  "Aligarh Muslim University": "aligarh_muslim_university.png",
  "University of Hyderabad": "university_of_hyderabad.png",
  "University of Allahabad": "university_of_allahabad.png",
  "Visva Bharati": "visva_bharati_university.png",
  "Ambedkar University Delhi": "ambedkar_university_delhi.jpeg",
  "Pondicherry University": "pondicherry_university.png",
  "Tezpur University": "tezpur_university.png",
  "Assam University": "assam_university.png",
  "Sikkim University": "sikkim_university.png",
  "Mizoram University": "mizoram_university.png",
  "Nagaland University": "nagaland_university.png",
  "Tripura University": "tripura_university.png",
  "Manipur University": "manipur_university.png",
  TISS: "tiss.png",
  "Hemvati Nandan Bahuguna Garhwal University":
    "hemvati_nandan_bahuguna_garhwal_university.png",
  "Guru Ghasidas Vishwavidyalaya": "guru_ghasidas_vishwavidyalaya.png",
  "Mahatma Gandhi Central University": "mahatma_gandhi_central_university.png",
  "North Eastern Hill University": "north_eastern_hill_university.png",
  "Rajiv Gandhi University": "rajiv_gandhi_university.png",
  "Central University of Gujarat": "central_university_of_gujarat.png",
  "Central University of Haryana": "central_university_of_haryana.png",
  "Central University of Himachal Pradesh":
    "central_university_of_himachal_pradesh.png",
  "Central University of Jammu": "central_university_of_jammu.png",
  "Central University of Jharkhand": "central_university_of_jharkhand.png",
  "Central University of Karnataka": "central_university_of_karnataka.png",
  "Central University of Kashmir": "central_university_of_kashmir.png",
  "Central University of Kerala": "central_university_of_kerala.png",
  "Central University of Odisha": "central_university_of_odisha.png",
  "Central University of Rajasthan": "central_university_of_rajasthan.png",
  "Central University of South Bihar": "central_university_of_south_bihar.png",
  "Central University of Tamil Nadu": "central_university_of_tamil_nadu.png",
  "Central University of Andhra Pradesh":
    "central_university_of_andhra_pradesh.png",
  "Babasaheb Bhimrao Ambedkar University":
    "babasaheb_bhimrao_ambedkar_university.png",
};

// Pre-import base image
let baseImage = null;
try {
  baseImage = require("../../../assets/images/university/central/base.png");
} catch (e) {
  // base image not available
}

// Cache for resolved images
const imageCache = {};

// Generate gradient colors for colleges
const gradientColors = [
  ["#1e3a5f", "#2563eb"],
  ["#1a4731", "#059669"],
  ["#4c1d95", "#7c3aed"],
  ["#92400e", "#d97706"],
  ["#991b1b", "#dc2626"],
  ["#1e3a5f", "#0891b2"],
  ["#312e81", "#6366f1"],
  ["#064e3b", "#10b981"],
];

/**
 * Get the image path for a college name
 */
export function getCollegeImagePath(collegeName) {
  if (imageCache[collegeName] !== undefined) {
    return imageCache[collegeName];
  }

  // Direct match
  if (collegeImageMap[collegeName]) {
    try {
      const img = require(`../../../assets/images/university/central/${collegeImageMap[collegeName]}`);
      imageCache[collegeName] = img;
      return img;
    } catch (e) {
      // ignore
    }
  }

  // Fallback to base image
  imageCache[collegeName] = baseImage;
  return baseImage;
}

/**
 * Get a gradient color pair for a college (consistent per college name)
 */
export function getCollegeGradient(collegeName) {
  let hash = 0;
  for (let i = 0; i < collegeName.length; i++) {
    hash = collegeName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % gradientColors.length;
  return gradientColors[index];
}
